<template>
  <div class="container admin">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>调剂</el-breadcrumb-item>
        <el-breadcrumb-item>调剂报告</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">调剂报告</h2>
        </div>
        <div class="right">
          <!-- <el-button
            class="button"
            type="primary"
            @click="SupplementCreateVisible = !SupplementCreateVisible"
            >新建</el-button
          > -->
        </div>
      </div>
    </div>

    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="订单号"
                      prop="order_no">
          <el-input v-model.trim="query.order_no"
                    placeholder="输入订单编号/交易单号"
                    @input="searchSetTimeout()"
                    clearable></el-input>
        </el-form-item>

        <!-- <el-form-item
          label="商品名称"
          prop="goods_name"
        >
          <el-input
            v-model.trim="query.goods_name"
            placeholder="输入商品名称"
            @input="searchSetTimeout()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商品类型"
          prop="ref_type"
        >
          <el-select
            v-model="query.ref_type"
            multiple
            collapse-tags
            clearable
            placeholder="请选择"
            style="width: 150px"
            @change="getDataList(true)"
          >
            <el-option
              v-for="item in filter.refTypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="用户昵称"
                      prop="user">
          <el-input v-model.trim="query.user"
                    placeholder="输入用户昵称/姓名/手机号"
                    clearable
                    @input="searchSetTimeout()"></el-input>
        </el-form-item>
        <el-form-item label="支付类型"
                      prop="pay_type">
          <el-select v-model="query.pay_type"
                     multiple
                     collapse-tags
                     placeholder="请选择"
                     clearable
                     @change="getDataList(true)">
            <el-option v-for="item in filter.payTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单类型"
                      prop="pay_type">
          <el-select v-model="query.order_types"
                     placeholder="请选择"
                     clearable
                     multiple
                     collapse-tags
                     @change="getDataList(true)">
            <el-option v-for="item in filter.orderTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态"
                      prop="status">
          <el-select v-model="query.status"
                     multiple
                     collapse-tags
                     placeholder="请选择"
                     clearable
                     @change="getDataList(true)">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="timechange"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="推荐人"
                      prop="category_id">
          <el-autocomplete class="inline-input"
                           v-model="admin_referrer"
                           :fetch-suggestions="querySearch"
                           placeholder="请输入内容"
                           :trigger-on-focus="false"
                           @select="handleSelect"
                           clearable
                           @clear="handleAutoClear"></el-autocomplete>
        </el-form-item>
      </el-form>
    </div>

    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="order_no"
                           label="订单编号"
                           min-width="160"
                           align="center">
          </el-table-column>

          <el-table-column prop="order_no"
                           label="调剂报告状态"
                           min-width="100"
                           align="center">
            <template slot-scope="scope">
              <el-tag :type="
                  scope.row.ref_adjust_report_show_status == 1
                    ? 'success'
                    : 'danger'
                ">
                {{
                  scope.row.ref_adjust_report_show_status == 1 ? "开启" : "关闭"
                }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="goods_name"
                           label="商品名称"
                           width="300"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.ref_type == 7">{{
                formatJointProduct(scope.row)
              }}</span>
              <span v-else>{{ scope.row.goods_name }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name"
                           label="商品类型"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span>{{ formatRef_type(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户信息"
                           width="200"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.user">{{
                `${scope.row.user.nickname}${
                  scope.row.user.realname ? `/${scope.row.user.realname}` : ""
                }`
              }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="total_amount"
                           label="订单金额"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.total_amount }}元</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付方式"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.pay_type == 0">-</span>
              <span v-else-if="scope.row.pay_type == 1">支付宝</span>
              <span v-else-if="scope.row.pay_type == 2">微信</span>
              <span v-else-if="scope.row.pay_type == 3">系统</span>
              <span v-else-if="scope.row.pay_type == 4">
                <span v-if="scope.row.hb_fq_seller_percent == 100">
                  花呗分期(免{{ scope.row.hb_fq_num }}期)
                </span>
                <span v-else>花呗分期</span>
              </span>
              <span v-else-if="scope.row.pay_type == 5">研币</span>
            </template>
          </el-table-column>
          <el-table-column label="订单类型"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{ typeformate(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <span>{{ statusRender(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="推荐人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateAdmin_referrer(scope.row.admin_referrer) }}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="240"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleDetail(scope.row)">详情</el-link>
              <el-link style="margin: 0 10px"
                       type="primary"
                       :underline="false"
                       @click="handleRegistration(scope.row)">报考信息</el-link>
              <!-- <el-link
                type="primary"
                :underline="false"
                @click="handleStatus(scope.row)"
                >调剂状态</el-link
              > -->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>

    <RegistrationInformation ref="registrationInformation" />
    <el-dialog title="信息详情"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               width="1080px"
               class="dialog">
      <ReportDetail :uid="uid"
                    :time="new Date()" />
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary"
                   @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { configureList, adjustUserLog, getAdjustUserLog } from '@/api/operation'
import { memberOrderList } from '@/api/member'
import RegistrationInformation from '@/components/adjust/report/RegistrationInformation.vue'
import ReportDetail from '@/components/adjust/report/ReportDetail.vue'
let Timer = null // 定时器
let TimerTime = 1000 // 定时器 等待时长

export default {
  components: {
    RegistrationInformation,
    ReportDetail,
  },
  data() {
    return {
      uid: '',
      dialogVisible: false,

      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        is_ref_adjust_user_log: 1,
        status: ['4'],
      },
      results: [],
      pageTotal: 0,
      createDatetime: '',
      admin_referrer: '',
      filter: {
        status: [
          { label: '待支付', value: '0' },
          { label: '已支付', value: '1' },
          { label: '待发货', value: '2' },
          { label: '待收货', value: '3' },
          { label: '已完成', value: '4' },
          { label: '已取消', value: '5' },
        ],
        payTypes: [
          { label: '支付宝', value: '1' },
          { label: '微信', value: '2' },
          { label: '系统', value: '3' },
          { label: '花呗分期', value: '4' },
          { label: '研币', value: '5' },
        ],
        refTypes: [
          { label: '课程', value: '1' },
          { label: '题库', value: '2' },
          { label: '专栏', value: '3' },
          { label: '资料', value: '4' },
          { label: '文章', value: '5' },
          { label: '学长', value: '6' },
          { label: '联报', value: '7' },
          { label: '组合购', value: '8' },
        ],
        orderTypes: [
          { label: '普通订单', value: '0' },
          { label: '拼团订单', value: '1' },
          { label: '优惠订单', value: '2' },
        ],
      },
    }
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  created() {
    this.getConfigureList()
    this.$store.dispatch('getAdminList')
  },
  methods: {
    handleDetail(row) {
      this.uid = row.uid
      this.dialogVisible = true
    },
    getDataList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      if (params.status) {
        params.status = params.status.filter((v) => v).join(',')
      }
      if (params.pay_type) {
        params.pay_type = params.pay_type.filter((v) => v).join(',')
      }
      if (params.ref_type) {
        params.ref_type = params.ref_type.filter((v) => v).join(',')
      }
      if (params.order_types) {
        params.order_types = params.order_types.filter((v) => v).join(',')
      }
      memberOrderList(params).then((res) => {
        this.pageTotal = res.count
        this.results = res.list

        // console.log("列表数据", res);
      })
    },

    handleRegistration(row) {
      this.$refs.registrationInformation.open(row)
    },

    handleStatus(row) {
      let status = null
      let statusID = null
      if (row.ref_adjust_report_show_status == 1) {
        status = '关闭'
        statusID = 0
      } else {
        status = '开启'
        statusID = 1
      }

      getAdjustUserLog({
        uid: row.uid,
      }).then((res) => {
        this.$confirm(`此操作将${status}调剂状态, 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            adjustUserLog({
              id: res.id,
              uid: row.uid,
              report_show_status: statusID,
            }).then(() => {
              this.getDataList()
              this.$message({
                type: 'success',
                message: '操作成功!',
              })
            })
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            })
          })
      })
    },

    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.getDataList(true)
      }, TimerTime)
    },

    timechange(e) {
      if (e == null) {
        this.query.startTime = ''
        this.query.endTime = ''
      }
      this.getDataList(true)
    },

    querySearch(queryString, cb) {
      var restaurants = this.$store.state.adminList.map((v) => {
        return {
          value: v.nickname,
          id: v.id,
        }
      })
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },

    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      this.getDataList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getDataList()
    },
    handleSelect(item) {
      this.query.admin_referrer = item.id
      this.getDataList(true)
    },
    handleAutoClear() {
      this.query.admin_referrer = ''
      this.getDataList(true)
    },
    getConfigureList() {
      configureList({}).then((res) => {
        let data = res.list
        this.query.ref_ids = [
          //   data.find((item) => item.code == "AdjustVipProductId").id,
          data.find((item) => item.code == 'AdjustSVipProductId').value,
          data.find((item) => item.code == 'AdjustSVipProductIdSub').value,
        ].join()
        // this.query.sku_ids = [
        //   data.find((item) => item.code == "AdjustSvipNormalSkuId").value,
        //   data.find((item) => item.code == "AdjustSvipServiceSkuId").value,
        // ].join();
        this.getDataList()
        console.log('query', this.query)
      })
    },

    formatRef_type(row) {
      const obj = {
        0: '无',
        1: '课程',
        2: '题库',
        3: '专栏',
        4: '资料',
        5: '文章',
        6: '学长',
        7: '联报',
      }
      return obj[row.ref_type] || ''
    },
    typeformate(row) {
      let arr = []
      if (row.user_coupon_id) {
        arr.push('优惠订单')
      } else if (row.activity_id) {
        arr.push('拼团订单')
      } else {
        return '普通订单'
      }
      return arr.join('/')
    },

    statusRender(row) {
      const order_status = {
        0: '待支付',
        1: '已支付',
        2: '待发货',
        3: '待收货',
        4: '已完成',
        5: '已取消',
      }
      const pay_status = {
        0: '待支付',
        1: '已支付',
        2: '已取消',
      }
      const audit_status = {
        0: '待审核',
        1: '审核通过',
        2: '审核未通过',
      }
      const refund_status = {
        0: '未申请',
        1: '退款中',
        2: '已退款',
      }
      return order_status[row.status] || ''
    },
    formateAdmin_referrer(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          return this.$store.state.adminList.find((v) => {
            return v.id == val
          }).nickname
        } else {
          return '无'
        }
      }
    },
  },
}
</script>

<style lang="less" scoped>
.card {
  position: relative;
  color: #303133;
  background-color: #fff;
  border: 1px solid #ebeef5;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
  padding: 20px;
}
.header {
  .breadcrumb {
    margin-bottom: 30px;
  }
  .title {
    font-size: 30px;
  }
  .content {
    display: flex;
    align-content: center;
    overflow-y: visible;
  }

  .left,
  .right {
    flex: 1;
  }
  .right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    text-align: center;

    .button {
      // font-size: 14px;
      // padding: 12px 20px;
    }
  }
}

.results {
  flex: 1;
  margin-top: 10px;

  .title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .values {
  }
  .avatar {
    display: block;
    width: 68px;
    height: 68px;
    object-fit: cover;
    margin: 0 auto;
  }
  .footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
}

.filters {
  margin-top: 10px;

  .search-wrap {
    margin-bottom: -18px;

    .datetime {
      width: 380px;
    }
  }
  .divider {
    border-bottom: 1px dashed #dcdfe6;
    margin: 15px 0;
  }
  .action-wrap {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
